import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_REST_API_VSMS
const baseEndpoint = '/assets/color'

export const getColor = async () => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: baseEndpoint,
  })

  return response?.data
}
